import type { NodeKind } from '@/types';

import { ALLOWED_CONNECTIONS } from './rules';

/**
 * 連線驗證結果
 */
export type ConnectResult =
  | { ok: true }
  | { ok: false; code: 'not-allowed' | 'same-node-root'; message: string };

/**
 * 判斷兩個節點類型是否允許連線
 * -----------------------------------------------------------------------------
 * 純函式、無副作用、與 React 解耦 —— 可直接寫單元測試（見 can-connect.test.ts）。
 *
 * 呼叫點：
 *   - `features/canvas/CoreCanvas.onConnect`（拖拉新邊時）
 *   - `features/canvas/CoreCanvas.addConcept` / 合併模式（程序化生成子鏈時的隱含約束）
 *   - `services.rulesEngine.validateEdge`（中介層）
 *
 * @param source 起始節點類型
 * @param target 目標節點類型
 * @returns 允許時 `{ ok: true }`；不允許時帶錯誤代碼與訊息
 * @example
 *   canConnect('tool', 'output'); // { ok: true }
 *   canConnect('output', 'output'); // { ok: false, code: 'not-allowed', ... }
 */
export function canConnect(source: NodeKind, target: NodeKind): ConnectResult {
  const allowed = ALLOWED_CONNECTIONS.some(([s, t]) => s === source && t === target);

  return allowed
    ? { ok: true }
    : { ok: false, code: 'not-allowed', message: `${source} cannot connect to ${target}` };
}
